import React, { useCallback, useState } from 'react';
import 'twin.macro';
import { StepWrapper } from 'containers/Demarrage/components/StepWrapper';
import Input from 'components/Form/Input2';
import { ZoneSelector } from 'components/ZoneEditor/ZoneSelector';
import { AustralianStateSelector } from 'containers/MesAnneesScolaires/SearchEtablissement/AustralianStateSelector';
import FormGroup from 'components/Form/FormGroup';
import { useUpdateDemarrage } from 'containers/Demarrage/queries/useUpdateDemarrage';
import { useDemarrage } from 'containers/Demarrage/queries/useDemarrage';
import _debounce from 'lodash-es/debounce';
import { ZoneId } from 'types/zone';
import { useTranslation } from 'react-i18next';
import { StateSelector } from 'containers/MesAnneesScolaires/SearchEtablissement/StateSelector';
import { getDefaultZone } from 'containers/useCountries';

export function EcoleDetails() {
  const update = useUpdateDemarrage();
  const { t } = useTranslation(['onboarding']);
  const { data: demarrageData } = useDemarrage();
  const [value, setValue] = useState<string>(demarrageData?.schoolName ?? '');

  const country = demarrageData?.userCountryCode ?? 'FR';
  const zoneId = demarrageData?.zoneId ?? getDefaultZone(country) ?? 'autre';

  const onZoneIdChange = (z: ZoneId) => update({ zoneId: z });

  const debouncedSave = useCallback(
    _debounce(nextValue => update({ schoolName: nextValue }), 400),
    [update],
  );

  const handleChange = nextValue => {
    setValue(nextValue);
    debouncedSave(nextValue);
  };
  return (
    <StepWrapper
      title={t('onboarding:schoolDetails.title')}
      currentStep="ecole-details"
      nextDisabled={!value}
    >
      <div tw="space-y-6">
        <FormGroup
          id="school-name"
          label={t('onboarding:schoolDetails.schoolNameLabel')}
        >
          <Input
            id="school-name"
            large
            autoFocus
            value={value}
            onChange={e => handleChange(e?.currentTarget.value)}
          />
        </FormGroup>
        <div>
          {country === 'AU' ? (
            <AustralianStateSelector
              extraLarge
              value={zoneId}
              onChange={onZoneIdChange}
            />
          ) : country === 'US' ? (
            <StateSelector
              extraLarge
              value={zoneId}
              onChange={onZoneIdChange}
            />
          ) : (
            <ZoneSelector
              extraLarge
              withWhiteBg
              value={zoneId}
              onChange={onZoneIdChange}
            />
          )}
        </div>
      </div>
    </StepWrapper>
  );
}
